export default __webpack_public_path__ + "static/media/Brochure_mr.4182c45e.pdf";